import http from "@/utils/http";
import * as urls from "@/recourses/urls/recombee";

export const getMostPurchaseRecommendations = async (userId: string, storeID: string) => {
  const url = new URL(urls.mostPurchaseProducts);

  if (userId) url.searchParams.append("user", userId);
  if (storeID) url.searchParams.append("store", storeID);

  return await http.get(url.toString(), {
    isAuth: true,
  });
};

export const getRelatedWhatYouSawRecommendations = async (userId: string, storeID: string) => {
  const url = new URL(urls.relatedWhatYouSaw);

  if (userId) url.searchParams.append("user", userId);
  if (storeID) url.searchParams.append("store", storeID);

  return await http.get(url.toString(), {
    isAuth: true,
  });
};

export const getMostPurchasedCategory = async (userId: string, storeID: string) => {
  const url = new URL(urls.mostPurchasedCategory);

  if (userId) url.searchParams.append("user", userId);
  if (storeID) url.searchParams.append("store", storeID);

  return await http.get(url.toString(), {
    isAuth: true,
  });
};

export const getMostPurchasedHub = async (userId: string, storeID: string) => {
  const url = new URL(urls.mostPurchasedHub);

  if (userId) url.searchParams.append("user", userId);
  if (storeID) url.searchParams.append("store", storeID);

  return await http.get(url.toString(), {
    isAuth: true,
  });
};
